import { connect } from 'react-redux';
import _get from 'lodash/get';
import { cmsLegalContent } from 'store/saga/entities/bound';
import LegalContentCms from './LegalContentCms';

const mapStateToProps = state => {
  const cmsData = cmsLegalContent.data(state);
  return {
    sections: _get(cmsData, 'data.sections', []),
  };
};

export default connect(mapStateToProps)(LegalContentCms);
